/*
 * @Author: your name
 * @Date: 2021-07-13 14:16:26
 * @LastEditTime: 2021-07-13 15:13:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/router/routes.js
 */
import freight from './freight';
import travel from './travel';

const entry = resolve => {
  require.ensure([], () => {
    resolve(require('../views/entry/index.vue'))
  }, 'index')
}

export default [
  {path: '/', component: entry, meta: {title: '发票'}},
  {path: '/appInvoiceEntry', component: entry, meta: {title: '发票'}},
  ...freight,
  ...travel
]




// WEBPACK FOOTER //
// ./src/router/routes.js